import { Control, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PlotPortfolioSubscription } from '@/api/rest/resources/types/plotPortfolioSubscriptions';
import { DateFormField, NumericFormField, SelectFormField, TextFormField } from '@/components';

export type JobSubscriptionFormValues = {
  ndi_plot_portfolio_subscription: string;
  display_name: string;
  start_date: string;
  end_date: string;
  job_creation_cost_credits: string;
  job_execution_cost_credits: string;
};

export const JobSubscriptionFormFields = ({
  control,
  plotPortfolioSubscriptions,
}: {
  control: Control<JobSubscriptionFormValues>;
  plotPortfolioSubscriptions: PlotPortfolioSubscription[];
}) => {
  const { t } = useTranslation();
  const invalidNumberMessage = t('shared.ndiOrganizationSubscriptions.formRules.invalidNumber');
  const startDate = useWatch({ control, name: 'start_date' });

  return (
    <>
      <SelectFormField
        control={control}
        name='ndi_plot_portfolio_subscription'
        label={t('shared.ndiOrganizationSubscriptions.fields.plotPortfolioSubscription')}
        placeholder={t('shared.ndiOrganizationSubscriptions.fields.plotPortfolioSubscriptionPlaceholder')}
        options={plotPortfolioSubscriptions.map((plotPortfolioSubscription) => ({
          value: plotPortfolioSubscription.id,
          label: plotPortfolioSubscription.display_name,
        }))}
      />
      <TextFormField
        control={control}
        name='display_name'
        label={t('shared.ndiOrganizationSubscriptions.fields.displayName')}
      />
      <DateFormField
        control={control}
        name='start_date'
        label={t('shared.ndiOrganizationSubscriptions.fields.startDate')}
      />
      <DateFormField
        control={control}
        name='end_date'
        label={t('shared.ndiOrganizationSubscriptions.fields.endDate')}
        min={startDate || undefined}
      />
      <NumericFormField
        control={control}
        name='job_creation_cost_credits'
        label={t('shared.ndiOrganizationSubscriptions.fields.jobCreationCostCredits')}
        invalidNumberMessage={invalidNumberMessage}
      />
      <NumericFormField
        control={control}
        name='job_execution_cost_credits'
        label={t('shared.ndiOrganizationSubscriptions.fields.jobExecutionCostCredits')}
        invalidNumberMessage={invalidNumberMessage}
      />
    </>
  );
};
